import styled from 'styled-components'

import IntlCurrencyInput from 'react-intl-currency-input'

export const Input = styled(IntlCurrencyInput)``
